import auth from "@/auth";
import { jwtDecode } from "jwt-decode";

let intervalId = null;

export function startIntervalRefreshToken() {
  const allCookies = document.cookie;

  const accessToken = allCookies
    .split("; ")
    .find(cookie => cookie.startsWith("access_token="))
    ?.split("=")[1];

  if (!accessToken) {
    stopTokenInterval();
    console.error("Access token not found.");
    return;
  }

  const decodedToken = jwtDecode(accessToken);
  if (decodedToken.exp === undefined) {
    stopTokenInterval();
    console.error("Token expiration not found.");
    return;
  }
  const tokenExp = decodedToken.exp;

  document.cookie = `token_exp=${tokenExp}; path=/;`;

  stopTokenInterval();
  getTokenInterval(tokenExp);
}

export function getTokenInterval(tokenExp) {
  const update = (tokenExp - 900) * 1000 - Date.now();

  if (intervalId) {
    clearTimeout(intervalId);
  }

  intervalId = setTimeout(() => {
    const accessToken = document.cookie
      .split("; ")
      .find(cookie => cookie.startsWith("access_token="))
      ?.split("=")[1];

    if (!accessToken) {
      return stopTokenInterval();
    }

    stopTokenInterval();

    // Новый цикл
    auth.refresh().then(() => {
      startIntervalRefreshToken();
    });
  }, Math.max(update, 0));
}

export function stopTokenInterval() {
  if (intervalId) {
    clearTimeout(intervalId);
    intervalId = null;
  }
}

export function checkAndStopTokenMonitoring() {
  const allCookies = document.cookie;
  const accessToken = allCookies
    .split("; ")
    .find(cookie => cookie.startsWith("access_token="))
    ?.split("=")[1];

  if (!accessToken) {
    stopTokenInterval();
  }
}